<template>
  <b-container fluid class="p-4">
    <b-row>
      <b-col lg="12">
        <div class="iq-edit-list-data">
          <iq-card>
            <template v-slot:body>
              <div v-if="leadSource == 'RRL' || leadSource == 'RDL'">
                <h4>{{ title }}</h4>
              </div>

              <div class="button-bar">
                <div class="items1">
                  <WDStepTitle
                    :propsMode="propsMode"
                    :quoteType="quoteType"
                    :quoteId="quoteId"
                    :status="vehicle.status"
                  />
                </div>
                <div class="items2"></div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6 col-lg-6 col-xl-3">
                  <div>
                    <div class="mb-3 mt-3">
                      <h5 class="text-info mb-0">Client Details</h5>
                    </div>
                    <div class="">
                      <div class="form-group">
                        <b-form-select
                          plain
                          autocomplete="off_title"
                          placeholder=" "
                          :options="optionTitle"
                          v-model="client.title"
                        ></b-form-select>
                        <label class="floatingLabel" for="title">Title</label>
                        <div
                          class="invalid-feedback"
                          v-if="getQuoteErrors['client.title']"
                        >
                          {{ fnReplace(getQuoteErrors['client.title']) }}
                        </div>
                      </div>

                      <div class="form-group">
                        <input
                          class="form-control"
                          type="text"
                          id="firstName"
                          autocomplete="off_firstName"
                          placeholder=" "
                          v-model="client.firstName"
                        />
                        <label class="floatingLabel" for="firstName"
                          >First Name</label
                        >
                        <div
                          class="invalid-feedback"
                          v-if="getQuoteErrors['client.firstName']"
                        >
                          {{ fnReplace(getQuoteErrors['client.firstName']) }}
                        </div>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          autocomplete="off_lastName"
                          id="lastName"
                          placeholder=" "
                          v-model="client.lastName"
                        />
                        <label class="floatingLabel" for="lastName"
                          >Surname</label
                        >
                        <div
                          class="invalid-feedback"
                          v-if="getQuoteErrors['client.lastName']"
                        >
                          {{ fnReplace(getQuoteErrors['client.lastName']) }}
                        </div>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          autocomplete="off_mobileNumber"
                          id="mobileNumber"
                          placeholder=" "
                          v-model="client.mobileNumber"
                        />
                        <label class="floatingLabel" for="mobileNumber"
                          >Mobile Number</label
                        >
                        <div
                          class="invalid-feedback"
                          v-if="getQuoteErrors['client.mobileNumber']"
                        >
                          {{ fnReplace(getQuoteErrors['client.mobileNumber']) }}
                        </div>
                      </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          type="text"
                          id="email"
                          autocomplete="off_email"
                          placeholder=" "
                          v-model="client.email"
                        />
                        <label class="floatingLabel" for="email">Email</label>
                        <div
                          class="invalid-feedback"
                          v-if="getQuoteErrors['client.email']"
                        >
                          {{ fnReplace(getQuoteErrors['client.email']) }}
                        </div>
                      </div>
                      <div class="form-group">
                        <input
                          type="number"
                          step="any"
                          class="form-control"
                          id="grossAnnualSalary"
                          placeholder=" "
                          autocomplete="off_grossAnnualSalary"
                          v-model="client.grossAnnualSalary"
                        />
                        <label class="floatingLabel" for="grossAnnualSalary"
                          >Gross Annual Salary ($)</label
                        >
                        <div
                          class="invalid-feedback"
                          v-if="getQuoteErrors['client.grossAnnualSalary']"
                        >
                          {{
                            fnReplace(
                              getQuoteErrors['client.grossAnnualSalary']
                            )
                          }}
                        </div>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          id="employerName"
                          placeholder=" "
                          autocomplete="off_employerName"
                          v-model="employment.employerName"
                        />
                        <label class="floatingLabel" for="employerName"
                          >Employer Name</label
                        >
                        <div
                          class="invalid-feedback"
                          v-if="getQuoteErrors['employment.employerName']"
                        >
                          {{
                            fnReplace(getQuoteErrors['employment.employerName'])
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 col-xl-3">
                  <div class="mb-3 mt-3">
                    <h5 class="text-info mb-0">Vehicle Details</h5>
                  </div>
                  <div class="form-group">
                    <b-form-select
                      plain
                      :options="optionVCondition"
                      placeholder=" "
                      autocomplete="off_vehicleCondition"
                      v-model="vehicle.vehicleCondition"
                    ></b-form-select>
                    <label class="floatingLabel" for="vehicleCondition"
                      >Vehicle Condition</label
                    >
                    <div
                      class="invalid-feedback"
                      v-if="getQuoteErrors['vehicle.vehicleCondition']"
                    >
                      {{
                        fnReplace(getQuoteErrors['vehicle.vehicleCondition'])
                      }}
                    </div>
                  </div>
                  <div
                    class="form-group"
                    v-if="vehicle.vehicleCondition !== 'N'"
                  >
                    <input
                      type="number"
                      step="any"
                      class="form-control"
                      id="odometerReading"
                      placeholder=" "
                      autocomplete="off_odometerReading"
                      v-model="vehicle.odometerReading"
                    />
                    <label class="floatingLabel" for="odometerReading"
                      >Odometer Reading</label
                    >
                    <div
                      class="invalid-feedback"
                      v-if="getQuoteErrors['vehicle.odometerReading']"
                    >
                      {{ fnReplace(getQuoteErrors['vehicle.odometerReading']) }}
                    </div>
                  </div>
                  <div class="form-group">
                    <input
                      type="number"
                      class="form-control"
                      id="year"
                      placeholder=" "
                      autocomplete="off_year"
                      v-model="vehicle.year"
                    />
                    <label class="floatingLabel" for="year">Year</label>
                    <div
                      class="invalid-feedback"
                      v-if="getQuoteErrors['vehicle.year']"
                    >
                      {{ fnReplace(getQuoteErrors['vehicle.year']) }}
                    </div>
                  </div>
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="make"
                      placeholder=" "
                      autocomplete="off_make"
                      v-model="vehicle.make"
                    />
                    <label class="floatingLabel" for="make">Make</label>
                    <div
                      class="invalid-feedback"
                      v-if="getQuoteErrors['vehicle.make']"
                    >
                      {{ fnReplace(getQuoteErrors['vehicle.make']) }}
                    </div>
                  </div>
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="model"
                      placeholder=" "
                      autocomplete="off_model"
                      v-model="vehicle.model"
                    />
                    <label class="floatingLabel" for="model">Model</label>
                    <div
                      class="invalid-feedback"
                      v-if="getQuoteErrors['vehicle.model']"
                    >
                      {{ fnReplace(getQuoteErrors['vehicle.model']) }}
                    </div>
                  </div>
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="variant"
                      placeholder=" "
                      autocomplete="off_variant"
                      v-model="vehicle.variant"
                    />
                    <label class="floatingLabel" for="variant">Variant</label>
                    <div
                      class="invalid-feedback"
                      v-if="getQuoteErrors['vehicle.variant']"
                    >
                      {{ fnReplace(getQuoteErrors['vehicle.variant']) }}
                    </div>
                  </div>
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="bodyType"
                      placeholder=" "
                      autocomplete="off_bodyType"
                      v-model="vehicle.bodyType"
                    />
                    <label class="floatingLabel" for="bodyType"
                      >Body Type</label
                    >
                    <div
                      class="invalid-feedback"
                      v-if="getQuoteErrors['vehicle.bodyType']"
                    >
                      {{ fnReplace(getQuoteErrors['vehicle.bodyType']) }}
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6 col-lg-6 col-xl-3">
                  <!--- Lease Details --->
                  <div>
                    <div class="mb-3 mt-3">
                      <h5 class="text-info mb-0">Lease Details</h5>
                    </div>

                    <div class="form-group">
                      <input
                        type="number"
                        step="any"
                        class="form-control"
                        id="totalDriveAwayCost"
                        placeholder=" "
                        autocomplete="off_totalDriveAwayCost"
                        v-model="vehicle.totalDriveAwayCost"
                      />
                      <label class="floatingLabel" for="totalDriveAwayCost"
                        >Total Drive Away Cost ($)</label
                      >
                      <div
                        class="invalid-feedback"
                        v-if="getQuoteErrors['vehicle.totalDriveAwayCost']"
                      >
                        {{
                          fnReplace(
                            getQuoteErrors['vehicle.totalDriveAwayCost']
                          )
                        }}
                      </div>
                    </div>

                    <!--- Options --->
                    <div>
                      <div class="mb-3 mt-5">
                        <h5 class="text-info mb-0">Options</h5>
                      </div>

                      <div class="row">
                        <!-- Refer Dealer  RDL: Refer Dealer Leads : Dealer can send Basic Lead form the portal-->
                        <div
                          class="col-12"
                          v-if="
                            propsMode == 'new' &&
                            leadSource == 'RDL' &&
                            getUserById
                          "
                        >
                          <div class="form-group">
                            <b-form-select
                              plain
                              :options="getAllAssociateWhichBelongsToUser"
                              value-field="id"
                              text-field="name"
                              placeholder=" "
                              autocomplete="off_term"
                              v-model="vehicle.dealerId"
                              @change="fnAssociateChange(vehicle.dealerId)"
                            ></b-form-select>
                            <label class="floatingLabel" for="leaseTerm"
                              >Select Dealer</label
                            >
                            <div
                              class="invalid-feedback"
                              v-if="getQuoteErrors['vehicle.dealerId']"
                            >
                              {{
                                fnReplace(getQuoteErrors['vehicle.dealerId'])
                              }}
                            </div>
                          </div>
                        </div>

                        <!-- Referral Partners RRL: Refer Referral Partner Leads: Referral can send Basic Lead form the portal -->
                        <div
                          class="col-12"
                          v-if="
                            propsMode == 'new' &&
                            leadSource == 'RRL' &&
                            getUserById
                          "
                        >
                          <div class="">
                            <div class="form-group">
                              <b-form-select
                                plain
                                autocomplete="off_referralPartnerId"
                                placeholder=" "
                                :options="getAllAssociateWhichBelongsToUser"
                                value-field="id"
                                text-field="name"
                                v-model="vehicle.referralPartnerId"
                                @change="
                                  fnAssociateChange(vehicle.referralPartnerId)
                                "
                              ></b-form-select>
                              <label
                                class="floatingLabel"
                                for="referralPartnerId"
                                >Referring partner</label
                              >
                              <div
                                class="invalid-feedback"
                                v-if="errors['vehicle.referralPartnerId']"
                              >
                                {{
                                  fnReplace(errors['vehicle.referralPartnerId'])
                                }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-12">
                          <label for="name"
                            >Upload vehicle pricing if available</label
                          >
                          <div class="sits-file-upload">
                            <input
                              type="file"
                              id="actual-btn"
                              ref="file"
                              @change="uploadFile"
                              hidden
                            />
                            <!-- our custom upload button -->
                            <label class="upload-label" for="actual-btn"
                              ><i
                                class="fas fa-cloud-upload-alt text-primary"
                              ></i>
                              Upload file</label
                            >

                            <!-- name of file chosen -->
                            <span
                              v-if="pricingDocument.name"
                              id="file-chosen"
                              >{{ pricingDocument.name }}</span
                            >
                          </div>
                        </div>

                        <div class="col-12 mt-3">
                          <button
                            class="btn btn-primary btn-sm"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Send Refer Lead to VSA"
                            @click="fnCreate()"
                          >
                            Send Refer Lead
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </iq-card>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { serialize } from 'object-to-formdata'
import * as messageService from '../../services/message.service'
import * as leadsService from '../../services/leads.service'
import * as authService from '../../services/auth.service'
import { optionTitle, optionVCondition } from '../../services/data.service'
import appModalQuoteEmailOptions from './ModalQuoteEmailOptions.vue'
import appModalUnlockMessage from './ModalUnlockMessage.vue'
import appWDDealer from '../wd/WDDealer.vue'
import appModalLeadsStatusUpdate from '../admin/ModalLeadsStatusUpdate.vue'
import appModalLeadsMsgVSA from '../leads/ModalLeadsMsgVSA.vue'
import WDStepTitle from '../wd/WDStepTitle.vue'

const options = {
  /**
   * include array indices in FormData keys
   * defaults to false
   */
  indices: false,

  /**
   * treat null values like undefined values and ignore them
   * defaults to false
   */
  nullsAsUndefineds: false,

  /**
   * convert true or false to 1 or 0 respectively
   * defaults to false
   */
  booleansAsIntegers: false,

  /**
   * store arrays even if they're empty
   * defaults to false
   */
  allowEmptyArrays: true,

  /**
   * don't include array notation in FormData keys for any Attributes excepted Files in arrays
   * defaults to false
   */
  noAttributesWithArrayNotation: false,

  /**
   * don't include array notation in FormData keys for Files in arrays
   * defaults to false
   */
  noFilesWithArrayNotation: true,

  /**
   * use dots instead of brackets for object notation in FormData keys
   * defaults to false
   */
  dotsForObjectNotation: false
}

export default {
  name: 'quoteBasic',
  props: {
    title: {
      type: String,
      required: true
    },
    propsMode: {
      type: String,
      required: true
    },
    quoteType: {
      type: String,
      required: true
    },
    leadSource: {
      type: String,
      required: false
    }
  },
  components: {
    appModalQuoteEmailOptions,
    appModalUnlockMessage,
    appWDDealer,
    appModalLeadsStatusUpdate,
    appModalLeadsMsgVSA,
    WDStepTitle
  },

  data() {
    return {
      quoteId: this.$route.params.quoteId,
      submit_mode: 'save',
      errors: {},
      settingAll: {},
      loginUser: {},
      step: 1,
      checkUnlocked: false,
      dealerInfo: {},
      referralPartnersInfo: {},
      referDealerInfo: {},
      selectedVSABrokerageOptions: [],
      isSave: false,
      pricingDocument: '',
      // client_vehicle_details
      vehicle: {
        id: '',
        clientId: '',
        dealerId: '',
        referralPartnerId: '',
        referDealerId: '',
        leadSource: this.leadSource || '',
        salaryPackagingProviderId: 1,
        salaryPackagingProviderFee: '',
        vehicleCondition: 'N',
        odometerReading: '',
        year: '',
        make: '',
        model: '',
        variant: '',
        bodyType: '',
        vehicleCategoryId: 1,
        fuelFlatRate: '',
        fuelCostPerKM: '',
        tyresCostPerKM: '',
        serviceCostPerKM: '',
        transmissionId: 1,
        fuelTypeId: 1,
        colour: '',
        accessories: '',
        term: 60,
        rvRate: '',
        annualKms: '',
        noFinanceInsurance: 0,
        comprehensiveInsurer: '',
        comprehensiveInsurancePremium: '',
        businessUsePercentage: 0,
        stampDuty: 0,
        registration: '',
        gstOnAsset: '',
        gstOnAssetActual: '',
        totalDriveAwayCost: '',
        chanageBudgetsYesNo: 'A',
        fuelBudget: '',
        serviceBudget: '',
        tyreBudget: '',
        needToCompeteYesNo: 'No',
        dealerBrokerage: '',
        status: 21,
        sortOrder: 6,
        has_messages: 0,
        messages_for_vsa: 0,
        messages_for_other: 0,
        privacyConsent: 0,
        settlementDate: '',
        fa_no: '',
        edd: ''
      },
      // Client information
      client: {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        mobileNumber: '',
        email: '',
        grossAnnualSalary: 0,
        payPeriod: 'Weekly',
        dateOfBirth: '',
        anotherNameYesNo: 'No',
        otherFirstName: '',
        otherMiddleName: '',
        otherLastName: '',
        driversLicenceNumber: '',
        driversLicenceCardNumber: '',
        driversLicenceExpiryDate: '',
        driversLicenceState: '',
        driversLicenceType: 'Full',
        maritalStatus: 'Single',
        numberOfDependents: '',
        partnerAnnualGrossSalary: '',
        australianResidencyStatusId: 1,
        visaTypeId: '',
        citizenOfAnotherCountryYesNo: 'No',
        citizenOfAnotherCountry: '',
        hAddressUnitNumber: '',
        hAddressStreetNumber: '',
        hAddressStreetName: '',
        hAddressSuburb: '',
        hAddressState: '',
        hAddressPostcode: '',
        hAddressCountry: 'Australia',
        hAddressTimeAtYears: 0,
        hAddressTimeAtMonths: 0,
        hAddressResidenceStatus: '',
        hAddressMonthlyRentalAmount: '',
        pHAddressUnitNumber: '',
        pHAddressStreetNumber: '',
        pHAddressStreetName: '',
        pHAddressSuburb: '',
        pHAddressState: '',
        pHAddressPostcode: '',
        pHAddressCountry: 'Australia',
        pHAddressTimeAtYears: '',
        pHAddressTimeAtMonths: 0,
        postalAddressAndHomeAddressAreSameYesNo: 'Yes',
        postalAddressPOBoxNumber: '',
        postalAddressSuburb: '',
        postalAddressState: '',
        postalAddressPostcode: '',
        status: 1
      },
      //client_employment_detailsgetStepNumber
      employment: {
        quoteId: '',
        employerName: '',
        tradingName: '',
        ABNOfEmployerOnPayslip: '',
        websiteAddress: '',
        employmentStatus: '',
        occupation: '',
        employerAddressBuildingName: '',
        employerAddressUnitNumber: '',
        employerAddressStreetNumber: '',
        employerAddressStreetName: '',
        employerAddressSuburb: '',
        employerAddressState: '',
        employerAddressPostcode: '',
        employerAddressTimeAtYears: 0,
        employerAddressTimeAtMonths: 0,
        employerContactName: '',
        employerContactNumber: '',
        pEmployerName: '',
        pABNOfEmployerOnPayslip: '',
        pEmploymentStatus: '',
        pOccupation: '',
        pEmployerAddressBuildingName: '',
        pEmployerAddressUnitNumber: '',
        pEmployerAddressStreetNumber: '',
        pEmployerAddressStreetName: '',
        pEmployerAddressSuburb: '',
        pEmployerAddressState: '',
        pEmployerAddressPostcode: '',
        pEmployerAddressTimeAtYears: 0,
        pEmployerAddressTimeAtMonths: 0,
        pEmployerContactName: '',
        pEmployerContactNumber: '',
        investmentIncome: 0,
        govConvertibleIncome: 0,
        otherIncome: 0,
        noteOnOtherIncome: ''
      },
      //client_finance_details
      finance: {
        quoteId: '',
        homePropertyValve: '',
        investmentProperty: [
          {
            value: '',
            limit: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        vehicleProperty: [
          {
            value: '',
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        otherMajorVehicles: '',
        superannuationBalance: '',
        toolsAndEquipment: '',
        sharesTrustsSMSF: '',
        cashInTheBank: '',
        homeContents: '',
        otherMajorAsset: '',
        listOtherMajorAsset: '',
        homeLoanBalance: '',
        homeLoanLimit: '',
        homeLoanLenderName: '',
        homeLoanMonthlyPayment: '',
        personalLoan: [
          {
            balance: '',
            lenderName: '',
            monthlyPayment: ''
          }
        ],
        creditCard: [
          {
            limit: '',
            lenderName: ''
          }
        ],
        privateSchoolFees: '',
        vehicleRunningCosts: '',
        livingExpenses: '',
        insurances: '',
        ratesPowerWater: '',
        entertainment: '',
        otherMajorMonthlyExpenses: '',
        totalMonthlyExpenses: 0
      },
      //client_application_notes
      notes: {
        applicationNotes: ''
      },
      //lookup value
      lookupValues: {
        FBTRate: '0',
        GAPInsurance: '0',
        GAPInsuranceVSA: '0',
        GST: '0',
        GSTLimit: '0',
        GSTMaxOnAssets: '0',
        PPSRFee: '0',
        brokerage: '0',
        brokerageVSADefault: '0',
        brokerageVSA: '0.05',
        id: -1,
        financierId: -1,
        interest: '0',
        leaseAdminFee: '0',
        leaseAdminFeeVSA: '0',
        mcLeaseFee: '0',
        medicare: '0',
        quoteId: -1,
        registration: '0',
        tyreReplaceFreq: '0',
        tyreWheelInsurance: '0'
      },
      optionTitle: optionTitle,
      optionVCondition: optionVCondition,
      optionFuelType: [{ text: 'Electricity', value: '4' }]
    }
  },
  computed: {
    ...mapGetters([
      'gettSettingAll',
      'getUserById',
      'getLookupValuesAll',
      'getQuoteErrors'
    ]),
    /**
     * This return Associate Dealers or Referral Partners Which Belongs login User
     */
    getAllAssociateWhichBelongsToUser() {
      /**
       * If new quote create by dealer staff, VSA Admin or VSA Staff, or BDM, dealers which blogs to them will list on the dropdown list
       * If the User has only one dealership and as a new quote
       */
      if (this.propsMode == 'new' && this.leadSource === 'RDL') {
        let arr = this.getUserById?.dealers

        if (arr == undefined) {
          return
        }

        if (arr.length == 1) {
          this.vehicle.dealerId = arr[0].id
          this.vehicle.dealerBrokerage = arr[0]?.referredLeadCommission

          return arr
        }

        return arr
      }

      if (this.propsMode == 'new' && this.leadSource === 'RRL') {
        let arr = this.getUserById?.referral_partners

        if (arr == undefined) {
          return
        }

        if (arr.length == 1) {
          this.vehicle.dealerId = arr[0].id || 73
          this.vehicle.referralPartnerId = arr[0].id
          this.vehicle.dealerBrokerage = arr[0]?.reporting_commission

          return arr
        }

        return arr
      }
    }
  },

  methods: {
    ...mapActions([
      'fetchSaveApplication',
      'fetchQuoteSingle',
      'fetchUserById',
      'fetchLookupValuesAll',
      'fetchQuoteErrors'
    ]),

    /**
     * New Leads
     */
    fnCreate: async function () {
      // To clear previous error messages
      this.fetchQuoteErrors(this.errors)

      let formDataDoc = new FormData()
      if (this.leadSource === 'RDL') {
        this.vehicle.referDealerId = this.vehicle.dealerId
      }

      if (this.leadSource === 'RRL') {
        this.vehicle.referralPartnerId = this.vehicle.referralPartnerId
      }

      formDataDoc.append('pricingDocument', this.pricingDocument)

      const allData = {
        quoteType: this.quoteType,
        propsMode: this.propsMode,
        submit_mode: this.submit_mode,
        leadSource: this.leadSource,
        vehicle: this.vehicle,
        client: this.client,
        employment: this.employment,
        finance: this.finance,
        notes: this.notes,
        lookupValues: this.lookupValues,
        pricingDocument: this.pricingDocument
      }

      try {
        this.errors = {}
        let response = ''

        if (this.quoteType == 'leads') {
          const formData = serialize(allData, options)
          response = await leadsService.add(formData)
        }

        if (
          response.status == 200 &&
          this.quoteType == 'leads' &&
          this.submit_mode == 'save'
        ) {
          const { message } = response.data

          if (message === 'Success') {
            if (this.leadSource == 'RDL') {
              this.$router.push({
                name: 'dealer.referLeadsList'
              })
            }

            if (this.leadSource == 'RRL') {
              this.$router.push({
                name: 'referralPartner.leadsList'
              })
            }
          }

          messageService.fnSweetAlertSuccessToast(
            'Lead - new',
            'Started new Lead successfully '
          )
        }
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            this.fetchQuoteErrors(this.errors)
            messageService.fnSweetAlertErrorToast(
              'Leads - new',
              'Mandatory fields are required'
            )
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Leads - new',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Leads - new',
              'Something wrong'
            )
            break
        }
      }
    },

    fnReplace(str) {
      const newString = str.toString().replace('[', '').replace(']', '')

      return newString
    },
    /**
     * To get maximum dealer commission which assign  each dealer on create
     * Each dealer user can work on at least one dealership or multiple dealer ship
     * So, we need to find selected dealer maximum dealer commission
     */
    fnAssociateChange(selectedId) {
      /**
       * If new quote create by dealer staff, VSA Admin or VSA Staff, or BDM, dealers which blogs to them will list on the dropdown list
       * If the User has only one dealership and as a new quote
       */
      if (this.propsMode == 'new' && this.leadSource === 'RDL') {
        let arr = this.getUserById?.dealers

        if (arr == undefined) {
          return
        }
        const dealer = arr.find((item) => item.id == selectedId)

        const { id, dealerBrokerage, referredLeadCommission } = dealer

        this.vehicle.dealerId = id
        this.vehicle.dealerBrokerage = referredLeadCommission

        return dealer
      }

      if (this.propsMode == 'new' && this.leadSource === 'RRL') {
        let arr = this.getUserById?.referral_partners

        if (arr == undefined) {
          return
        }

        const referralPartners = arr.find((item) => item.id == selectedId)

        const { id, dealerBrokerage, reporting_commission } = referralPartners

        this.vehicle.dealerId = 73
        this.vehicle.referralPartnerId = arr[0].id
        this.vehicle.dealerBrokerage = arr[0]?.reporting_commission

        return referralPartners
      }
    },

    /**
     * To get maximum referral partner commission which assign  each referral partner on create
     * Each referral partner user can work on at least one dealership or multiple dealer ship
     * So, we need to find selected dealer maximum dealer commission
     */

    uploadFile() {
      this.pricingDocument = this.$refs.file.files[0]
    }
  },
  async created() {
    this.loginUser = authService.getUserFromToken()

    if (this.propsMode == 'new') {
      await this.fetchUserById(this.loginUser.id)

      this.lookupValues.financierId = Number(
        this.getLookupValuesAll?.financierId
      )
    }

    await this.fetchLookupValuesAll()
  }
}
</script>
